import type { SeoBodyFaqItem } from "../seoMeta";

// 5 questions issues des PAA Google (FR). Reponses 40-60 mots. Aucun tiret
// cadratin (guard test). Partage entre seoMeta.ts (SSR + sitemap) et la page
// React (accordeon visible + FAQPage JSON-LD client).
export const JOURNAL_DE_TRADING_FAQ: SeoBodyFaqItem[] = [
  {
    question: "Comment faire un journal de trading ?",
    answer:
      "Notez chaque trade dès sa clôture : instrument, sens, prix d'entrée et de sortie, résultat, puis votre setup et vos notes. Avec Edgely, la synchronisation automatique Tradovate (plan Max) remplit votre journal toute seule ; l'import CSV et la saisie manuelle restent disponibles. Ajoutez un screenshot, une note, et laissez l'application calculer vos statistiques.",
  },
  {
    question: "Quel journal de trading gratuit choisir ?",
    answer:
      "Le plan gratuit d'Edgely permet de journaliser un nombre illimité de trades sur un compte, sans carte bancaire. Vous obtenez win rate, profit factor et courbe d'équité calculés automatiquement. C'est le moyen le plus simple de démarrer un journal de trading en français sans dépenser un euro.",
  },
  {
    question: "Que noter dans un journal de trading ?",
    answer:
      "Notez l'instrument, le sens, les prix d'entrée et de sortie, le résultat, mais surtout le contexte : votre setup, votre état mental et vos erreurs. Ce sont ces notes qualitatives qui révèlent votre edge et vos biais récurrents, bien plus que les chiffres bruts pris isolément.",
  },
  {
    question: "Existe-t-il un journal de trading en français ?",
    answer:
      "Oui. Edgely est un journal de trading entièrement en français, pensé pour les prop traders futures francophones. Interface, analytics, support et Prop Firm Manager sont en français, contrairement à la plupart des solutions américaines comme Tradezella ou TraderSync.",
  },
  {
    question: "Quelle différence entre Excel et une application ?",
    answer:
      "Sur Excel, vous saisissez tout à la main et vos formules cassent vite. Une application comme Edgely importe vos trades automatiquement, calcule vos métriques sans erreur et gère vos règles de drawdown prop firm. Vous gagnez du temps et vos statistiques restent fiables à mesure que votre historique grossit.",
  },
];
